module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Enter your new password","subtitle":"Fill in your email and password to proceed","password":"Password","password-confirmation":"Confirm your password","send":"Send"},"pt-br":{"title":"Redefinir senha","subtitle":"Digite sua nova senha","password":"Senha","password-confirmation":"Confirme sua senha","send":"Enviar"}}')
  delete Component.options._Ctor
}
